import { MemberCode } from '@/typings/subscribe'
import i18n from '@/i18n'
import { I18nKeys } from '@/constants/i18n'

// @ts-ignore
// const t = i18n.global.t

export enum LoginType {
  /**
   * 账号密码登录
   */
  PASSWORD = 'password',
  /**
   * 手机验证码登录
   */
  SMS = 'sms',
  /**
   * 微信扫码登录
   */
  WeChat = 'wechat_qrcode',
  /**
   * discord
   */
  DISCORD = 'discord',
  /**
   * google
   */
  GOOGLE = 'google'
}

/**
 * 每邀请一个用户，活得免费会员天数
 */
export const GIFT = 15

/**
 * 会员等级
 */
export enum MemberLevel {
  FREE = 1,
  TRIAL = 50,
  PERSONAL = 100,
  PERSONAL_PAYPAL = 101,
  PERSONAL_STRIPE = 102,
  PROFESSIONAL = 200,
  STARTER = 100,
  PLUS = 199,
  PRO = 202,
  ENTERPRISE = 300,
  ENTERPRISE_CUSTOMIZED = 400
}

/**
 * 会员等级同时生成最大任务数
 */
export const MemberMaxTaskCount = {
  [MemberCode.free]: 2,
  [MemberCode.trial]: 2,
  [MemberCode.starter]: 2, // STARTER一样
  [MemberCode.personal]: 2,
  [MemberCode.professional]: 4,
  [MemberCode.plus]: 4,
  [MemberCode.pro]: 8,
  [MemberCode.enterprise]: 8,
  [MemberCode.enterpriseCustomized]: 10000000
}

export const MemberTipsBuilder = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [MemberCode.free]: '',
    [MemberCode.trial]: t(I18nKeys.subscribe.memberTipsTrial),
    [MemberCode.personal]: t(I18nKeys.subscribe.memberTipsPersonal),
    [MemberCode.professional]: t(I18nKeys.subscribe.memberTipsProfessional),
    [MemberCode.enterprise]: t(I18nKeys.subscribe.memberTipsEnterprise),
    [MemberCode.enterpriseCustomized]: t(I18nKeys.subscribe.memberTipsEnterpriseCustomized)
  }
}

export const MemberTipsBuilderIntl = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [MemberCode.free]: '',
    [MemberCode.starter]: t(I18nKeys.subscribe.memberTipsStarter),
    [MemberCode.plus]: t(I18nKeys.subscribe.memberTipsPlus),
    [MemberCode.pro]: t(I18nKeys.subscribe.memberTipsPro)
  }
}

export const MemberDescBuilder = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [MemberCode.free]: [
      {
        label: t(I18nKeys.subscribe.memberFreeDesc1LabelLocal),
        value: t(I18nKeys.subscribe.memberFreeDesc1ValueLocal)
      },
      {
        label: t(I18nKeys.subscribe.memberFreeDesc2Label),
        value: t(I18nKeys.subscribe.memberFreeDesc2ValueLocal)
      },
      {
        label: t(I18nKeys.subscribe.memberFreeDesc3Label),
        value: t(I18nKeys.subscribe.memberFreeDesc3Value)
      },
      {
        label: t(I18nKeys.subscribe.memberFreeDesc4Label),
        value: t(I18nKeys.subscribe.memberFreeDesc4Value)
      }
    ],
    [MemberCode.trial]: [
      {
        label: t(I18nKeys.subscribe.memberDescPersonal1Label),
        value: t(I18nKeys.subscribe.memberDescPersonal1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal2Label),
        value: t(I18nKeys.subscribe.memberDescPersonal2Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal7Label),
        value: t(I18nKeys.subscribe.memberDescPersonal7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal3Label),
        value: t(I18nKeys.subscribe.memberDescPersonal3Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal4Label),
        value: t(I18nKeys.subscribe.memberDescPersonal4Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal5Label),
        value: t(I18nKeys.subscribe.memberDescPersonal5Value, {
          count: MemberMaxTaskCount[MemberCode.trial]
        })
      }
    ],
    [MemberCode.personal]: [
      {
        label: t(I18nKeys.subscribe.memberDescPersonal1Label),
        value: t(I18nKeys.subscribe.memberDescPersonal1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal2Label),
        value: t(I18nKeys.subscribe.memberDescPersonal2Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal7Label),
        value: t(I18nKeys.subscribe.memberDescPersonal7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal3Label),
        value: t(I18nKeys.subscribe.memberDescPersonal3Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal4Label),
        value: t(I18nKeys.subscribe.memberDescPersonal4Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPersonal5Label),
        value: t(I18nKeys.subscribe.memberDescPersonal5Value, {
          count: MemberMaxTaskCount[MemberCode.personal]
        })
      }
    ],
    [MemberCode.professional]: [
      {
        label: t(I18nKeys.subscribe.memberDescProfessional1Label),
        value: t(I18nKeys.subscribe.memberDescProfessional1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescProfessional2Label),
        value: t(I18nKeys.subscribe.memberDescProfessional2Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescProfessional7Label),
        value: t(I18nKeys.subscribe.memberDescProfessional7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescProfessional3Label),
        value: t(I18nKeys.subscribe.memberDescProfessional3Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescProfessional4Label),
        value: t(I18nKeys.subscribe.memberDescProfessional4Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescProfessional5Label),
        value: t(I18nKeys.subscribe.memberDescProfessional5Value, {
          count: MemberMaxTaskCount[MemberCode.professional]
        })
      }
      // '批量抠图：每批上限 10 张'
    ],
    [MemberCode.enterprise]: [
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise1Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise2Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise2Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise3Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise3Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise4Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise4Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise5Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise5Value, {
          count: MemberMaxTaskCount[MemberCode.enterprise]
        })
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise6Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise6Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise7Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterprise8Label),
        value: t(I18nKeys.subscribe.memberDescEnterprise8Value)
      }
    ],
    [MemberCode.enterpriseCustomized]: [
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized1Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized2Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized2Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized3Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized3Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized4Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized4Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized5Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized5Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized6Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized6Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescEnterpriseCustomized7Label),
        value: t(I18nKeys.subscribe.memberDescEnterpriseCustomized7Value)
      }
    ]
  }
}

export const MemberDescBuilderIntl = () => {
  // @ts-ignore
  const t = i18n.global.t

  return {
    [MemberCode.free]: [
      {
        label: t(I18nKeys.subscribe.memberFreeDesc1Label),
        value: t(I18nKeys.subscribe.memberFreeDesc1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberFreeDesc2Label),
        value: t(I18nKeys.subscribe.memberFreeDesc2Value)
      },
      {
        label: t(I18nKeys.subscribe.memberFreeDesc3Label),
        value: t(I18nKeys.subscribe.memberFreeDesc3Value)
      }
    ],
    [MemberCode.starter]: [
      {
        label: t(I18nKeys.subscribe.memberDescStarter0Label),
        value: t(I18nKeys.subscribe.memberDescStarter0Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescStarter1Label),
        value: t(I18nKeys.subscribe.memberDescStarter1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescStarter7Label),
        value: t(I18nKeys.subscribe.memberDescStarter7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescStarter2Label),
        value: t(I18nKeys.subscribe.memberDescStarter2Value, {
          count: MemberMaxTaskCount[MemberCode.starter]
        })
      },
      {
        label: t(I18nKeys.subscribe.memberDescStarter8Label),
        value: ''
      },
      {
        label: t(I18nKeys.subscribe.memberDescStarter9Label),
        value: ''
      },
      // {
      //   label: t(I18nKeys.subscribe.memberDescStarter4Label),
      //   value: t(I18nKeys.subscribe.memberDescStarter4Value)
      // },
      // {
      //   label: t(I18nKeys.subscribe.memberDescStarter5Label),
      //   value: t(I18nKeys.subscribe.memberDescStarter5Value)
      // },
      // {
      //   label: t(I18nKeys.subscribe.memberDescStarter6Label),
      //   value: t(I18nKeys.subscribe.memberDescStarter6Value)
      // }
    ],
    [MemberCode.plus]: [
      {
        label: t(I18nKeys.subscribe.memberDescPlus0Label),
        value: t(I18nKeys.subscribe.memberDescPlus0Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPlus1Label),
        value: t(I18nKeys.subscribe.memberDescPlus1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPlus7Label),
        value: t(I18nKeys.subscribe.memberDescPlus7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPlus2Label),
        value: t(I18nKeys.subscribe.memberDescPlus2Value, {
          count: MemberMaxTaskCount[MemberCode.plus]
        })
      },
      {
        label: t(I18nKeys.subscribe.memberDescPlus8Label),
        value: ''
      },
      {
        label: t(I18nKeys.subscribe.memberDescPlus9Label),
        value: ''
      },
      // {
      //   label: t(I18nKeys.subscribe.memberDescPlus3Label),
      //   value: t(I18nKeys.subscribe.memberDescPlus3Value)
      // },
      // {
      //   label: t(I18nKeys.subscribe.memberDescPlus4Label),
      //   value: t(I18nKeys.subscribe.memberDescPlus4Value)
      // },
      // {
      //   label: t(I18nKeys.subscribe.memberDescPlus5Label),
      //   value: t(I18nKeys.subscribe.memberDescPlus5Value)
      // },
      // {
      //   label: t(I18nKeys.subscribe.memberDescPlus6Label),
      //   value: t(I18nKeys.subscribe.memberDescPlus6Value)
      // },
      {
        label: t(I18nKeys.subscribe.memberDescPlus10Label),
        value: ''
      }
      // '批量抠图：每批上限 10 张'
    ],
    [MemberCode.pro]: [
      {
        label: t(I18nKeys.subscribe.memberDescPro0Label),
        value: t(I18nKeys.subscribe.memberDescPro0Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPro1Label),
        value: t(I18nKeys.subscribe.memberDescPro1Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPro7Label),
        value: t(I18nKeys.subscribe.memberDescPro7Value)
      },
      {
        label: t(I18nKeys.subscribe.memberDescPro2Label),
        value: t(I18nKeys.subscribe.memberDescPro2Value, {
          count: MemberMaxTaskCount[MemberCode.pro]
        })
      },
      {
        label: t(I18nKeys.subscribe.memberDescPro8Label),
        value: ''
      },
      {
        label: t(I18nKeys.subscribe.memberDescPro9Label),
        value: ''
      },
      {
        label: t(I18nKeys.subscribe.memberDescPro10Label),
        value: ''
      },
      // {
      //   label: t(I18nKeys.subscribe.memberDescPro6Label),
      //   value: t(I18nKeys.subscribe.memberDescPro6Value)
      // }
    ]
  }
}

export const UserPromotions = {
  /**
   * 第一次登录，弹出收到奖励窗口
   */
  USER_REGISTER_FIRST_MEMBER_RECEIVE_TOAST: 'user-register-first-member-receive-toast',
  /**
   * 从未订阅过
   */
  USER_FIRST_SIGN_REWARD_TOAST: 'user-first-sign-reward-toast',
  /**
   * 客户端首次登录
   */
  APP_USER_FIRST_USE_APP_REWARD: 'app-user-first-use-app-reward',
  /**
   * 需要分配奖励任务
   */
  USER_GUIDE_TASK_ASSIGN: 'user-guide-task-assign',
  /**
   * 任务已过期或已完成
   */
  USER_GUIDE_TASK_EXPIRED: 'user-guide-task-expired'
}

export const DISCORD_REDIRECT_URI = import.meta.env.DEV
  ? 'http://localhost:3001/signup'
  : import.meta.env.VITE_DISCORD_REDIRECT_URI

export const APP_LOGIN_REDIRECT_URI = import.meta.env.DEV
  ? 'http://localhost:3001/welcome'
  : import.meta.env.VITE_APP_LOGIN_REDIRECT_URI

export const STRIPE_SUCCESS_URL = import.meta.env.DEV
  ? 'http://localhost:3001/stripe'
  : import.meta.env.VITE_STRIPE_SUCCESS_URL

export const STRIPE_CANCEL_URL = import.meta.env.DEV
  ? 'http://localhost:3001/stripe'
  : import.meta.env.VITE_STRIPE_CANCEL_URL

export const APP_SCHEME = import.meta.env.VITE_APP_SCHEME

export { MemberCode }
